import integrationsClient, { type ApiDefinitions } from '@/tsClient/servers/governmentIntegrationsService';
import buildPath from '@/tsClient/utilities/buildPath';

type THIS_API = ApiDefinitions['/{provider}/user-workflows/{userWorkflowId}/case-submission-attempt']['DELETE'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

/** Soft-deletes the latest manual case submission attempt for a workflow, un-marking it as filed. */
const deleteCaseSubmissionAttempt = async ({ provider, userWorkflowId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/{provider}/user-workflows/{userWorkflowId}/case-submission-attempt', {
    provider,
    userWorkflowId,
  });
  const response = await integrationsClient.delete(path);
  return response.data;
};

export default deleteCaseSubmissionAttempt;
